import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import './IsBandSelectCard.scss';

interface IIsBandSelectCardProps {
  isBand: boolean;
  isSelected?: boolean;
  onClick?: (isBand: boolean) => void;
  disabled?: boolean;
}

const IsBandSelectCard = ({
  isBand,
  isSelected,
  onClick,
  disabled,
}: IIsBandSelectCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('is-band-select-card', { isSelected, disabled })}
      onClick={() => !disabled && onClick && onClick(isBand)}
    >
      <div className="is-band-select-card-header">
        <div className="is-band-select-card-header-name">
          {t(`is-band.${String(isBand)}.name`)}
        </div>
        <div className="is-band-select-card-header-description">
          {t(`is-band.${String(isBand)}.description`)}
        </div>
      </div>
      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default IsBandSelectCard;
